import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Box from "@mui/material/Box";
import { changePassword } from "domain/apis/authService";
import _ from "lodash";
import { useEffect } from "react";
import { FormPasswordUIItem } from "../commons";
import { useState } from 'react';

function ChangePasswordDialog({ show, handleClose, data }) {
    const [formUI, setFormUI] = useState({});
    const [error, setError] = useState({});
    const [confirmNewPasswordError, setConfirmNewPasswordError] = useState({});

    useEffect(() => {
        setError({});
    }, [show]);

    useEffect(() => {
        if (!data) {
            setFormUI({});
        } else {
            setFormUI(data);
        }
    }, [data, show]);

    const handleUpdateForm = (key, value) => {
        let obj = {};
        obj[key] = value;
        setFormUI({
            ...formUI,
            ...obj,
        })
    };

    const validateForm = () => {
        var result = true;
        var errorState = {};

        if (!formUI["password"] || formUI["password"] === '') {
            result = false;
            errorState.password = true;
        }

        if (!formUI["newPassword"] || formUI["newPassword"] === '') {
            result = false;
            errorState.newPassword = true;
        }

        if (formUI["newPassword"] !== formUI["reNewPassword"]) {
            result = false;
            errorState.reNewPassword = true;
            setConfirmNewPasswordError("Mật khẩu không khớp");
        }

        if (!formUI["reNewPassword"] || formUI["reNewPassword"] === '') {
            result = false;
            errorState.reNewPassword = true;
            setConfirmNewPasswordError("Vui lòng nhập!");
        }

        setError(errorState);
        return result;
    }

    const onModify = () => {
        if (!validateForm()) {
            return;
        }

        changePassword(formUI).subscribe({
            next: () => {
                handleClose(true);
            },
            error: (err) => {
                alert(err.message);
            }
        });
    };

    return (
        <>
            <Modal
                show={show}
                onHide={() => handleClose()}
                centered
                style={{ zIndex: 10000 }}
            >
                <Modal.Header>
                    <div
                        style={{ display: "flex", justifyContent: "center", width: "100%" }}
                    >
                        <Modal.Title>Thay đổi mật khẩu</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                            <FormPasswordUIItem
                                label={"Mật khẩu hiện tại"}
                                code={"password"}
                                error={_.get(error, "password")}
                                errorMessage={"Vui lòng nhập!"}
                                required
                                initValue={_.get(data, "password")}
                                handleUpdate={handleUpdateForm}
                            />
                            <FormPasswordUIItem
                                label={"Mật khẩu mới"}
                                code={"newPassword"}
                                error={_.get(error, "newPassword")}
                                errorMessage={"Vui lòng nhập!"}
                                required
                                initValue={_.get(data, "newPassword")}
                                handleUpdate={handleUpdateForm}
                            />
                            <FormPasswordUIItem
                                label={"Xác nhận mật khẩu mới"}
                                code={"reNewPassword"}
                                error={_.get(error, "reNewPassword")}
                                errorMessage={confirmNewPasswordError}
                                required
                                initValue={_.get(data, "reNewPassword")}
                                handleUpdate={handleUpdateForm}
                            />
                        </Box>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => handleClose()}>
                        Hủy
                    </Button>
                    <Button variant="primary" onClick={() => onModify()}>
                        Đổi mật khẩu
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default ChangePasswordDialog;
